import api from '../../api/api.js'
import { Message } from 'element-ui'
import login from '../../api/moudles/login.js'
import newOrders from '../../api/moudles/newOrders.js'




import {
	SET_STORAGE_USERINFO,
	SET_LOGINSTATUS,
	SET_USER_INFO,
	SET_REGISTOR_SUCCESS,
	SET_LOGIN_STATUS,
	SWITCH_LANG,
	SET_REGISTOR_FALSE

} from '../mutation-types'
import { resolve } from 'path'

const state = () => ({
	userInfo: JSON.parse(localStorage.getItem('userInfo')) || '',
	loginStatus: false,
	registorSuccess: false,
	hasLogin: false,
	lang: localStorage.lang || 'zh',


})

const getters = {}

const actions = {
	//印尼用户注册
	registerByIdonsia({ commit }, payload) {
		login
			.registerByIdonsia(payload)
			.then(res => {
				if (res.code === 200) {
					Message({
						message: '注册成功,正前往登录页！',
						type: 'success'
					})
					commit(SET_REGISTOR_SUCCESS)
				} else if (res.code === 500) {

					Message({
						message: res.msg,
						type: 'warning'
					})
				}
			})
	},
	//修改密码
	changePws({ commit }, payload) {
		const p = new Promise((resolve) => {
			login
				.changePws(payload)
				.then(res => {
					resolve(res)
				})
		})

		return p

	},
	//修改密码，获取邮箱验证码
	getEmailCode_changepws({ commit }, payload) {
		login
			.getEmailCode_changepws(payload)
			.then(res => {
				if (res.code === 200) {
					Message({
						message: '成功发送邮箱验证码',
						type: 'success'
					})
				} else if (res.code === 500) {

					Message({
						message: res.msg,
						type: 'warning'
					})
				}
			})
	},
	//邮箱注册
	getRegister({ commit }, payload) {
		const p = new Promise(resolve => {
			login
				.getRegister(payload)
				.then(res => {
					if (res.code === 200) {
						Message({
							message: '注册成功',
							type: 'success'
						})
						resolve('hasSuccess')
					} else {
						Message({
							message: res.msg,
							type: 'success'
						})
					}
				})
		})
		return p

	},
	//获取邮箱验证码
	getEmailCode({ commit }, payload) {
		login
			.getEmailCode(payload)
			.then(res => {
				if (res.code === 200) {
					Message({
						message: '成功发送邮箱验证码',
						type: 'success'
					})
				} else if (res.code === 500) {

					Message({
						message: res.msg,
						type: 'warning'
					})
				}
			})
	},
	//登录
	getLoginIn({ commit }, payload) {
		const p = new Promise((resolve) => {

			api
				.getLoginIn(payload)
				.then(res => {
					if (res.code === 200) {

						if (res.data) {
							resolve(res)
							commit(SET_STORAGE_USERINFO, res.data),
							commit(SET_USER_INFO, res.data)
							commit(SET_LOGINSTATUS)
							commit(SET_LOGIN_STATUS)
						}


					} else if (res.code === 1013) {
						Message({
							message: res.msg,
							type: 'error'
						})

					} else if (res.code === 1012) {
						Message({
							message: res.msg,
							type: 'error'
						})
					} else {
						Message({
							message: res.msg,
							type: 'error'
						})
					}
				})
		})

		return p

	},


	//手机验证码登录
	getLoginByPhoneCode({ commit }, payload) {
		const p = new Promise((resolve) => {
			newOrders
				.getLoginInfo(payload)
				.then(res => {
					if (res.code === 200) {

						if (res.data) {
							resolve(res)
							commit(SET_STORAGE_USERINFO, res.data),
							commit(SET_USER_INFO, res.data)
							commit(SET_LOGINSTATUS)
							commit(SET_LOGIN_STATUS)
						}


					} else if (res.code === 1013) {
						Message({
							message: res.msg,
							type: 'error'
						})

					} else if (res.code === 1012) {
						Message({
							message: res.msg,
							type: 'error'
						})
					} else {
						Message({
							message: res.msg,
							type: 'error'
						})
					}
				})
		})

		return p

	},

	//注册
	getRegistor({ commit }, payload) {
		const p = new Promise((resolve) => {
			resolve('hasRegistor')
			// api
			// .getRegistor(payload)
			// .then(res => {
			// 	if(res.code ===200) {
			// 		if(res.msg === "success") {
			// 			alert('注册成功,请重新登录')
			// 			let ttp=true
			// 			resolve(ttp)

			// 		}

			// 	}else if(res.code === 1013) {
			// 		alert(res.msg)
			// 	}else if(res.code === 1012) {
			// 		alert(res.msg)
			// 	}else if(res.code === 1010) {
			// 		alert(res.msg)
			// 	}

			// })	
		})
		return p
	}
}

const mutations = {
	[SET_STORAGE_USERINFO]: (state, data) => {
		if (data.userId == 'ABH_Int') {
			data.partnerId = 28
		}
		if (data.userPos === 'STORE') {
			localStorage.setItem('shophasAuthorization', true)
			localStorage.setItem('storeBindShopList', JSON.stringify(data.sellers))
		}
		if (data.shopeeShops || data.lazadaShops || data.tiktokShops) {
			localStorage.setItem('shophasAuthorization', true)
		} else {
			localStorage.setItem('shophasAuthorization', false)
		}

		localStorage.setItem('usreFirstLogin', JSON.stringify(true))
		localStorage.setItem('userInfo', JSON.stringify(data))
		localStorage.setItem('shopIdInfo', JSON.stringify(data.shopeeShops))
		localStorage.setItem('warehouse', JSON.stringify(data.stores))
		localStorage.setItem('lazadashopId', JSON.stringify(data.lazadaShops))
		localStorage.setItem('temuAuth', JSON.stringify(data.temuAuth))
	},
	[SET_LOGINSTATUS]: (state) => {
		state.loginStatus = true
	},
	[SET_USER_INFO]: (state, data) => {
		state.userInfo = data
	},

	[SET_REGISTOR_SUCCESS]: (state) => {
		state.registorSuccess = true

	},
	[SET_REGISTOR_FALSE]: (state) => {
		state.registorSuccess = false

	},
	[SET_LOGIN_STATUS]: (state) => {
		state.hasLogin = true
	},
	[SWITCH_LANG]: (state, data) => {
		state.lang = data
		localStorage.setItem('lang', data)
	},


}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}